import React from 'react';
import { createPortal } from 'react-dom';
import { useRef, useEffect } from 'react';
import GetPropertyExplorerNavTabs from '/src/services/Content/GetPropertyExplorerNavTabs';
import CTAButton from '/src/Components/CTAButton/CTAButton';
import greenDot from '/src/assets/Green-Dot-4.svg';
import PropertyExplorerAboutSections from '/src/Components/PropertyExplorerAboutSections/PropertyExplorerAboutSections';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { CircleX } from 'lucide-react';


import './style.css';

const FirstViewExplainer = ({ handleOutsideClick }) => {

    const popupRef = useRef(null);
    const navTabs = GetPropertyExplorerNavTabs();
    const navTabsWithoutLastTab = navTabs.slice(0, -1);
    const refineAnalyisTab = navTabs.find(tab => tab.id === 'personalize');


    useEffect(() => {
        const handleClick = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                handleOutsideClick?.();
            }
        };

        if (handleOutsideClick) {
            document.addEventListener('mousedown', handleClick);
            return () => document.removeEventListener('mousedown', handleClick);
        }
    }, [handleOutsideClick]);

    // Add effect to handle body scroll
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    const header = "This Can Be Personalized Even More!"
    const intro = "What you're going to see for this home is so much more than a report. It is a tool, to not only educate you on the property's risks, but provide guidance and tools for protecting you wallet and future:"
    const conclusion_sentence = "This is so much more than an report, it is a tool. There is a lot in here so take a deep breath and move at your own pace."
    const CTAButtonText = "Dive in!"

    const refineAnalysisExplanation = "Want to further tailor the intelligence to you or think any numbers look a little off? Just click this icon on the top right of the page, update details about the house and your preferences, and we'll re-process the entire analysis. Don't worry, your data is never shared!"

    const refineAnalysisIconFilename = "property-explorer-personalize-icon.svg"
    const refineAnalysisIconUrl = CreateCloudfrontUrl(refineAnalysisIconFilename)

    return createPortal(
        <div className="first-view-explainer-overlay">
            <div className="first-view-explainer-popup" ref={popupRef}>
                <CircleX className="first-view-explainer-close-icon" onClick={handleOutsideClick} />
                <div className="first-view-explainer-container">

                    <h1>{header}</h1>
                    <div className="first-view-explainer-section-icon-frame">
                        <div className="first-view-explainer-section-icon-container-background refine-analysis-explanation-icon-container-background">
                            <img src={greenDot} alt="green dot" />
                        </div>
                        <div className="first-view-explainer-section-icon-container">
                            <img className="first-view-explainer-section-icon" src={refineAnalysisIconUrl} alt={refineAnalyisTab.name} />
                        </div>
                    </div>
                    <p className="first-view-explainer-intro text-align-center" dangerouslySetInnerHTML={{ __html: refineAnalysisExplanation }} />
                    {/* <PropertyExplorerAboutSections /> */}

                    {/* <div className="first-view-explainer-refine-analysis-explanation-container">
                        <span className="first-view-explainer-refine-analysis-explanation-container-content-container-details text-align-center" dangerouslySetInnerHTML={{ __html: refineAnalysisExplanation }} />

                    </div> */}
                    {/* <p dangerouslySetInnerHTML={{ __html: conclusion_sentence }} /> */}
                    <CTAButton text={CTAButtonText} onClick={handleOutsideClick} />
                </div>
            </div>
        </div>,
        document.body
    );
};

export default FirstViewExplainer;